import MobileTopUpPage from './MobileTopUpPage.vue';
import MobileTopUpProductPage from './MobileTopUpProductPage.vue';

export default [
  {
    path: '/mobile-top-up',
    name: 'mobile-topup',
    component: MobileTopUpPage,
    meta: { title: 'Recharge mobile' }
  },
  {
    path: '/mobile-top-up/:slug',
    name: 'mobile-topup-product',
    component: MobileTopUpProductPage,
    meta: { title: 'Recharge mobile - Détails' }
  }
];
